import { ControlPanelIP, RegisterEndpoint } from "utils/config";
import { Storage } from "utils/storage";
import MemoryStorage from "utils/MemoryStorage";
import { userPool } from "utils/awsAuth";

const DEFAULTS = {
	method: "get",
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json; charset=utf-8",
	},
};

function handleErrors(response) {
	return new Promise((resolve, reject) => {
		if (!response.ok) {
			reject(response);
			return
		}
		resolve(response);
		return;
	});
}

export async function getLocal(url, opts) {
	const auth = {
		method: "get",
		mode: "no-cors",
	};

	return fetch(url, { ...auth, ...opts });
}

export async function get(url, opts) {
	let storage = new Storage();
	const keyPrefix = `CognitoIdentityServiceProvider.${userPool.getClientId()}`;
	const lastUserKey = `${keyPrefix}.LastAuthUser`;
	const username = await storage.getItem(lastUserKey);

	const idTokenKey = `${keyPrefix}.${username}.idToken`;

	const value = await storage.getItem(idTokenKey);

	const auth = {
		...DEFAULTS,
		headers: {
			...DEFAULTS.headers,
			Authorization: value,
		},
	};

	return fetch(url, { ...auth, ...opts }).then(handleErrors);
}

export async function post(url, {
	mode, mvalue, mmin, mmax, version, timer, online,
	S1,	S2,	S3,	S4,	S5,	S6,	S7,	SA,	SF,	SE
}, opts) {
	let storage = new Storage();
	const keyPrefix = `CognitoIdentityServiceProvider.${userPool.getClientId()}`;
	const lastUserKey = `${keyPrefix}.LastAuthUser`;
	const username = await storage.getItem(lastUserKey);

	const idTokenKey = `${keyPrefix}.${username}.idToken`;
	const value = await storage.getItem(idTokenKey);

	const auth = {
		method: "post",
		mode: "cors",
		headers: {
			...DEFAULTS.headers,
			Authorization: value,
		},
		body: JSON.stringify({
			mode, mvalue, mmin, mmax, version, timer, online, S1,	S2,	S3,	S4,	S5,	S6,	S7,	SA,	SF,	SE,
		}),
	};

	return new Promise((resolve, reject) => {
		fetch(url, { ...auth, ...opts })
			.then(res => {
				if (res.ok) {
					return resolve(res);
				} else {
					return reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
}

export async function addDevice(deviceId) {
	// TODO: should add new friendlyname field
	let storage = new Storage();
	const keyPrefix = `CognitoIdentityServiceProvider.${userPool.getClientId()}`;
	const lastUserKey = `${keyPrefix}.LastAuthUser`;
	const username = await storage.getItem(lastUserKey);

	const idTokenKey = `${keyPrefix}.${username}.idToken`;
	const value = await storage.getItem(idTokenKey);


	console.log(deviceId);
	const auth = {
		method: "post",
		mode: "cors",
		headers: {
			...DEFAULTS.headers,
			Authorization: value,
		},
		body: JSON.stringify({
			deviceId,
		}),
	};

	return new Promise((resolve, reject) => {
		fetch(RegisterEndpoint, { ...auth })
			.then(res => {
				if (res.ok) {
					return resolve(res);
				} else {
					return reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
}

// TODO: this should call API to AWS to get user's devices (SPECIFIC TO USER), must return friendly name as well
export async function getCurrentUserDevices() {
	console.log("getCurrentUserDevices")

	if (!this.state.deviceId) {
		get(ControlPanelIP)
			.then(res => res.json())
			.then(async result => {
					console.log("func - getCurrentUserDevices", result);
					this.setState({
						deviceId: result.devices[0],
					});
					if (result.devices[1]) {
						this.setState({
							deviceId1: result.devices[1],
						});
					};
					if (result.devices[2]) {
						this.setState({
							deviceId2: result.devices[2],
						});
					};
				})
	};


	return new Promise((resolve, reject) => {
		return resolve([{deviceId: this.state.deviceId, friendlyName: this.state.deviceId}, {deviceId: 'DEV2', friendlyName: 'Downstairs'}]);
	});

}



// WEBPACK FOOTER //
// ./src/api/index.js